import { GetVerificationCodeBatchesParams, VerificationCodeBatchSortByParam } from "@bvhi/backend-api/apis";

export const defaultVerficationCodesFilter: GetVerificationCodeBatchesParams = {
  page: 0,
  size: 25,
  sort: [VerificationCodeBatchSortByParam.CREATED_AT_ASC],
};
